import { IconCheck, IconX } from '@tabler/icons-react';
import * as React from 'react';
import type { SerializableRenderTreeNode } from '../../../../../../react-commons/components/data-display/tree/RenderTreeNode';
import { Tree } from '../../../../../../react-commons/components/data-display/tree/Tree';
import { QueryBaseComponent } from '../../../../../../react-commons/query/QueryBaseComponent';
import { ControlledInputs } from '../../../../../../react-commons/utils/read-only-inputs/controlledInputs';
import { compareByName } from '../../../../../../react-commons/utils/utilFunctions';
import { SplitPane } from '../../../../../../react-commons/views/split-pane/SplitPane';
import { type RoleResource, useRoleActions } from '../../../../resource/resources/artifacts/role/roleResource';

type AssociatedRolesInWorkflowComponentTreeNode = SerializableRenderTreeNode<RoleResource>; // TODO

export const AssociatedRolesInWorkflowComponent = ({
    workflowRepresentationId,
    projectVersionId,
}: {
    workflowRepresentationId: string | undefined;
    projectVersionId: string | undefined;
}) => {
    const [nodes, setNodes] = React.useState<Array<AssociatedRolesInWorkflowComponentTreeNode>>([]);
    const [selectedNode, setSelectedNode] = React.useState<AssociatedRolesInWorkflowComponentTreeNode | null>(null);

    const roleAdapterActions = useRoleActions();
    const rolesQuery = roleAdapterActions.useGetAllResources(projectVersionId);
    const affectedRoleIds = roleAdapterActions.useGetAllRoleIdsInProjectUsedInWorkflowRepresentation(
        projectVersionId,
        workflowRepresentationId
    );

    React.useEffect(() => {
        const newNodes =
            rolesQuery.data?.toSorted(compareByName).map((role) => ({
                key: role.id,
                label: role.name,
                data: role,
            })) ?? [];

        setNodes(newNodes);

        if (!selectedNode) {
            setSelectedNode(newNodes[0] ?? null);
        }
    }, [rolesQuery.data, selectedNode]);

    return (
        <QueryBaseComponent name={'Affected Roles Id'} query={affectedRoleIds}>
            {(affectedRoles) => (
                <QueryBaseComponent name={'Roles'} query={rolesQuery}>
                    {(roles) => (
                        <div style={{ width: 800, height: 500 }}>
                            <SplitPane secondaryInitialSize={60}>
                                <Tree
                                    nodes={nodes}
                                    filtered={true}
                                    selectedNodeKey={selectedNode?.key}
                                    onNodeSelected={(node) => {
                                        setSelectedNode(node);
                                    }}
                                    getElements={(node) => ({
                                        icon:
                                            affectedRoles.includes(node.data.id) ?
                                                <IconCheck
                                                    style={{ fontSize: '1.15rem', paddingRight: 2 }}
                                                    color={'var(--mantine-color-primaryTeal-filled)'}
                                                />
                                            :   <IconX
                                                    style={{ fontSize: '1.15rem', paddingRight: 2 }}
                                                    color={'var(--mantine-color-error)'}
                                                />,
                                    })}
                                />
                                <div
                                    style={{
                                        display: 'inline-block',
                                        verticalAlign: 'top',
                                        overflowY: 'auto',
                                        width: '100%',
                                        height: '100%',
                                    }}
                                >
                                    {selectedNode && (
                                        <ControlledInputs.MultilineString
                                            nullable={false}
                                            value={
                                                roles.find((value) => value.id === selectedNode.key)?.description ?? ''
                                            }
                                            readOnly={true}
                                            rows={20}
                                            minRows={20}
                                            maxRows={20}
                                            autosize={false}
                                            resize={false}
                                            label={'Selected Role Description'}
                                        />
                                    )}
                                </div>
                            </SplitPane>
                        </div>
                    )}
                </QueryBaseComponent>
            )}
        </QueryBaseComponent>
    );
};
